var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2NewHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair-3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M477.2,181.2c20.6,9.9,7.8,54.5,4.1,66.4c17.7-13.7,41.8-38.3,46.6-59.8c4.9-21.6,21.5-63.5-23.3-109.3 c-32.7-33.3-87.9-61-123.3-62c-39.4-1.2-107.7,16.3-138.7,34c-46.7,26.7-70,80.7-69.3,104c0.6,19.9,4.2,46.7,15.3,62 c7.4,10.1,22.1,22.1,36,22.7c-13.2-9.2-18-51.3,10.7-52.7c-12.8-16.6,44.2-18,53.5-18.8c39.7-3.4,81.6-7.8,121,1.3 C432.6,174.3,460.2,171,477.2,181.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_7_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M519,186.8c4.1-4.2,20.2-17.7,13.6-22C434.5,147.1,332.9,142.3,233,153c-13.2,1.4-26.3,3-39.4,4.9 c-7.4,1.2-14.8,2.6-22.2,4.1c-1.7,4.1,4.7,11.3,7,14c4.4,5,8.9,10.4,13.9,14.9c5.6,5.1,12.6,9.4,19.4,9.6 c91.1-18.6,187.6-16.2,280,0.7C503.7,200.8,511.5,194.3,519,186.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M221.8,154.2c-9.4,1.1-18.9,2.3-28.3,3.7c-7.4,1.2-14.8,2.6-22.2,4.1c-1.7,4.1,4.7,11.3,7,14 c4.4,5,8.9,10.4,13.9,14.9c5.6,5.1,12.6,9.4,19.4,9.6c33.1-6.7,66.8-10.7,100.8-12.2C279.3,183,245.4,174.6,221.8,154.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M229.5,67.9c-10.4,25.1-18,60.1-19.4,87.8c7.6-1,15.2-1.9,22.9-2.7c87.1-9.3,175.4-6.8,261.6,5.6 c-2.4-32.5-7.8-64.5-18.8-94.7C411.1,46.3,304.5,38.8,229.5,67.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M229.5,67.9c-8.4,20.3-15,46.9-17.9,71c11.8-2.1,23.9-4,36.2-5.5c0.5-24.9,5.3-53.8,11.8-74.9 C249.2,61.1,239.1,64.2,229.5,67.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M211.6,138.9c-0.7,5.8-1.2,11.4-1.5,16.8c7.6-1,15.2-1.9,22.9-2.7c87.1-9.3,175.4-6.8,261.6,5.6 c-0.4-5.1-0.8-10.2-1.4-15.3C408,124,300.8,122.7,211.6,138.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M444.3,134.5c-8.3-1.1-16.8-2.1-25.3-3l0.7,18.9c8.5,0.6,17,1.4,25.5,2.2L444.3,134.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2NewHair3);
export default __webpack_public_path__ + "static/media/m-hat2_new-hair3.090a13b218075cc107c974d227547bdd.svg";
export { ForwardRef as ReactComponent };